import styled from '@emotion/styled';
import { rem } from 'polished';

export const RCTHeader = styled.div<{ productCount: number }>`
  display: grid;
  grid-template-columns: 1fr repeat(${props => props.productCount}, 1fr);
  height: ${rem('164px')};
  font-family: VodafoneLight;
  align-items: center;
  width: 100%;
`;

export const RCTTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${rem('30px')};
  align-items: start;
  padding: 0 ${rem('20px')};
  justify-content: center;
  #rtc-expand-all-mobile {
    display: none;
  }
  #rtc-expand-all-desktop {
    display: flex;
  }
  [class*='Interactionstyle__Button-sc'] {
    display: none;
  }
  h4 {
    margin: 0;
  }
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    align-items: center;
    padding: 0 ${rem('10px')};
    gap: 0;
    justify-self: center;
    h4 {
      display: none;
    }
    [class*='Interactionstyle__Button-sc'] {
      display: flex;
      min-width: 100%;
    }
    #rtc-expand-all-mobile {
      display: block;
    }
    #rtc-expand-all-desktop {
      display: none;
    }
  }
`;

export const RCTProductHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-left: 1px solid #7e7e7e;
  height: 100%;
  justify-content: center;
  align-items: center;

  gap: ${rem('20px')};
  padding: ${rem('8px')} ${rem('20px')};
  h5 {
    justify-self: start;
    align-self: start;
  }

  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    overflow: hidden;
    [class*='Interactionstyle__Button-sc'] {
      display: none;
    }
    h5 {
      //fliptexttovertical
      justify-self: center;
      align-self: center;

      font-size: ${rem('16px')};
      writing-mode: sideways-lr;
    }
    &:last-child {
      border-right: 1px solid #7e7e7e;
    }
  }
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    h5 {
      font-size: ${rem('14px')};
    }
  }
`;
